import { Accordion, Divider, Flex } from '@mantine/core';

import { NumberInput, TextInput } from '@components';
import { CustomsTradeSendReportSettings } from './CustomsTradeSendReportSettings';
import { SendReportSettings } from './SendReportSettings';

export const HighValueSettings = ({ renderTemplateArrayField, handleChange, form, editDisabled }) => {
  return (
    <Accordion variant="filled">
      <Accordion.Item key="othersMappings" value="othersMappings">
        <Accordion.Control>Other mappings</Accordion.Control>
        <Accordion.Panel>{renderTemplateArrayField('highValueSettings.othersMappings', editDisabled)}</Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item key="packagingList" value="packagingList">
        <Accordion.Control>Packaging list</Accordion.Control>
        <Accordion.Panel>
          <NumberInput
            value={form.values.highValueSettings.packagingList.startRowIndex}
            onChange={(event) => {
              handleChange(event, 'highValueSettings.packagingList.startRowIndex');
            }}
            label="Start row index"
            w={160}
            m="md"
            disabled={editDisabled}
          />
          <Flex m="md" gap="md" wrap="wrap">
            <TextInput
              value={form.values.highValueSettings.packagingList.shippingMarksColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.shippingMarksColumn');
              }}
              label="Shipping marks column"
              w={210}
              disabled={editDisabled}
            />
            <TextInput
              value={form.values.highValueSettings.packagingList.descriptionOfGoodsColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.descriptionOfGoodsColumn');
              }}
              label="Description of goods column"
              w={250}
              disabled={editDisabled}
            />
            <TextInput
              value={form.values.highValueSettings.packagingList.quantityCountColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.quantityCountColumn');
              }}
              label="Quantity count column"
              w={210}
              disabled={editDisabled}
            />
            <TextInput
              value={form.values.highValueSettings.packagingList.packagesCountColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.packagesCountColumn');
              }}
              label="Packages count column"
              w={210}
              disabled={editDisabled}
            />
            <TextInput
              value={form.values.highValueSettings.packagingList.grossWeightColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.grossWeightColumn');
              }}
              label="Gross weight column"
              w={190}
              disabled={editDisabled}
            />
            <TextInput
              value={form.values.highValueSettings.packagingList.netWeightColumn}
              onChange={(event) => {
                handleChange(event.target.value, 'highValueSettings.packagingList.netWeightColumn');
              }}
              label="Net weight column"
              w={180}
              disabled={editDisabled}
            />
          </Flex>
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item key="shipmentsMapping" value="shipmentsMapping">
        <Accordion.Control>Shipments mappings</Accordion.Control>
        <Accordion.Panel>
          <NumberInput
            value={form.values.highValueSettings.shipmentsMapping.startRowIndex}
            onChange={(event) => {
              handleChange(event, 'highValueSettings.shipmentsMapping.startRowIndex');
            }}
            label="Start row index"
            w={160}
            m="md"
            disabled={editDisabled}
          />
          <Divider size={0} w="100%" style={{ borderBottom: '1px solid #ccc' }} />
          {renderTemplateArrayField('highValueSettings.shipmentsMapping.mappingFields', editDisabled)}
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item key="stakeholdersMapping" value="stakeholdersMapping">
        <Accordion.Control>Stakeholder mappings</Accordion.Control>
        <Accordion.Panel>{renderTemplateArrayField('highValueSettings.stakeholdersMapping', editDisabled)}</Accordion.Panel>
      </Accordion.Item>

      <SendReportSettings form={form} handleChange={handleChange} editDisabled={editDisabled} />

      <CustomsTradeSendReportSettings form={form} handleChange={handleChange} editDisabled={editDisabled} />
    </Accordion>
  );
};
